import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MainComponent } from './main/main.component';
import { AuthGuard } from '@mydocma/auth';
import { SingleTabGuard } from '@mydocma/app-container';
import { RedirectPageComponent } from './redirect-page/redirect-page.component';


const routes: Routes = [
  {
    path: '',
    canActivate: [SingleTabGuard],
    component: MainComponent,
    children: [
      {
        path: '',
        canActivate: [AuthGuard],
        loadChildren: () => import('../../projects/mydocma/co/src/lib/bp-routing/bp-routing.module')
          .then(mod => mod.BpRoutingModule),
      }
    ],
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
